export default __webpack_public_path__ + "static/media/newsSafety.67e7d8aa.png";